<template>
  <v-container fluid style="height:100%">
    <v-row justify="center" style="height:90%">
      <v-card
        tile
        height="95vh"
        style="border-radius: 25px 25px 0 0; pr-0;font-size:100%;background-color: white"
        width="95vw"
        :style="bdyColor"
      >
        <v-container
          class="fluid height_resp_350 header_height_resp ipad_resp"
          :style="bcgColor"
          style="width:100%;"
        >
          <v-row
            style="width:100%; height:100%"
            justify="end"
            align="center"
            light
          >
            <v-btn icon @click="cancelClick">
              <CloseIcon style="fill:#0247A7" />
            </v-btn>
          </v-row>
        </v-container>
        <v-container
          class="fluid pr-2  pr-6 pb-5 ipad_resp"
          :style="bdyColor"
          style=" width:100%;height:86%"
          id="modalContainer"
        >
          <v-row  justify="center" align="center">
            <v-col cols="12" :style="bdyColor" class="no_spc_less_300 ma-0 auto">
                <v-tabs
                  v-model="tab"
                  light
                  class="d-flex justify-center left_mrg_16 no_spc_less_300"
                  style="width:100%"
                  color="transparent"
                >
                  <v-tab light @click="tabVal" :style="[styleHeader1,bdyColor]">
                    <component v-bind:is="getTabHeader1"></component>
                  </v-tab>
                  <v-divider vertical></v-divider>
                  <v-tab light @click="tabVal" :style="[styleHeader2,bdyColor]" v-show="!FrThTabHeader">
                    <component v-bind:is="getTabHeader2"></component>
                  </v-tab>
                  <v-divider vertical  v-show="allTabHeader"></v-divider>
                  <v-tab light @click="tabVal" :style="[styleHeader3,bdyColor]"  v-if="getTabHeader3">
                    <component v-bind:is="getTabHeader3"></component>
                  </v-tab>
                </v-tabs>
            </v-col>
          </v-row>

          <v-row
            style=" border: 1px solid #C9CACB; margin-left:0.1%"
            justify="center"
            class="pa-0 mb-0 ipad_flex "
            v-show="isDisc"
          >
            <v-col cols="3" class="ma-0 pa-0 img_height_ord" style="width:100%">
              <v-img
                :src="discImgSrc"
                class="ma-0 pa-0"
                height="100%"
                width="100%"
                style="background:#4E5D6B"
              >
              </v-img>
            </v-col>
            <v-col class="py-0 " cols="9" v-show="checkOptin">
              <v-col cols="12" class="py-0 pr-0 " >
                <v-row style="width:100%; padding-left:12px;">
                  <span style="font-weight:bold;font-size:120%; color:#5686F6" class="mt-2">
                    {{ dscntCd }}
                  </span>
                </v-row>

                <v-row
                  style="width:100%; padding-left:12px;"
                  align="center"

                >
                <span class="py-5">
                  {{ dscntInstr }}
                </span>
                </v-row>
                <v-row style="width:100%; padding-left:12px;" align="start">
                  <v-btn

                    outlined
                    :key="widgetKey"
                    v-clipboard:copy="dscntCd"
                    v-clipboard:success="cpySuccess"
                    style="width: 95% !important;background-color:rgb(86, 134, 246)"
                  >
                  <span :style="btnTextProps">
                    {{ cpyBtnTxt }}
                  </span>
                  </v-btn>
                </v-row>
              </v-col>
            </v-col>
            <v-col class="py-0 pr-0" cols="9" v-show="!checkOptin">
              <v-col cols="12" class="no_y_spc_500 px-0" style="height:100%" >
                <v-col cols="12" class="px-0 py-0"
                  style="width:100%; padding-left:12px; padding-right:10px"
                >
                <span style="font-weight:bold; font-size:82%" class="pt-2 resp_cd" :style="msgProps">
                  {{ dscntStmt }}
                </span>
                </v-col>
                <v-col style="width:100%;" class="mt-2 pl-0 py-0 no_pr_resp">
                  <v-tabs-items v-model="tab" style="width:100%">
                    <v-tab-item :value="getTabKeySMS" style="width:100%;">
                      <v-col style="width:100%; height:80px !important;" class="px-0 py-0">
                        <v-col cols="12" class="px-0 py-0" style="padding-left:6%;height: 80px  !Important" :style="bdyColor">
                          <v-col class="px-0 py-0 resp_tel_inp_width" style="height: 36px !important;" >
<!--                            <v-col-->
<!--                              class="px-0 py-0"-->
<!--                              style="max-width:145px"-->
<!--                              v-if="!loadReady"-->
<!--                              cols="12"-->
<!--                            >-->
<!--                              <v-progress-linear-->
<!--                                color="blue-grey lighten-3"-->
<!--                                indeterminate-->
<!--                                rounded-->
<!--                                height="2"-->
<!--                              ></v-progress-linear>-->
<!--                            </v-col>-->
<!--                            <vue-tel-input-vuetify-->
<!--                              type="number"-->
<!--                              v-model="optinNum"-->
<!--                              v-bind="bindProps"-->
<!--                              v-on:country-changed="countryChanged"-->
<!--                              @onValidate="btnDisabled = $event.valid"-->
<!--                              @keydown="checkValidNumber($event)"-->
<!--                              required-->
<!--                              placeholder=""-->
<!--                              label=""-->
<!--                              class="phone_number_section"-->
<!--                              v-show="loadReady"-->
<!--                              :class="{ 'alerts-border': displaeErr }"-->
<!--                            >-->
<!--                              &lt;!&ndash;                            :placeholder="$t('settingsPage.addYourPhoneNumber')"&ndash;&gt;-->
<!--                              &lt;!&ndash;                            <v-icon slot="append" :color="stickerColor">mdi-sticker</v-icon>&ndash;&gt;-->
<!--                            </vue-tel-input-vuetify>-->
<!--                          </v-col>-->

                            <vue-tel-input
                              v-model="optinNum"
                              dark
                              style="width:100%; height:35px !important ;"
                              :showDialCode="true"
                              mode="international"
                              :class="{ 'alerts-border': displaeErr }"
                              :style="telNumErr"
                              type="number"
                              v-on:country-changed="countryChanged"
                              @onValidate="btnDisabled = $event.valid"
                              @keydown="checkValidNumber($event)"
                              required
                              placeholder=""
                              :label="$t('settingsPage.addYourPhoneNumber')"
                              class="phone_number_section"
                            >
<!--                              :placeholder="$t('settingsPage.addYourPhoneNumber')"-->
                            </vue-tel-input>

                          </v-col>

                          <v-col cols="12" class="px-0 " align="start" >
                            <v-btn
                              :style="buttonProps"
                              outlined
                              :key="widgetKey"
                              @click.once="submitClickDisc"
                              class="spc_ipad resp_tel_inp_width"
                            >
                              <span :style="btnTextProps">
                                {{ buttonText }}
                              </span>
                            </v-btn>

                          </v-col>
                        </v-col>
                      </v-col>
                    </v-tab-item>
                    <v-tab-item :value="getTabKeyFb" :style="bdyColor">

                      <component v-bind:is="currentTabComponent" class="mb-1"> </component>
                      <v-row style="width:100%; padding-left:6%;height:110px !important;"  align="start">

                        <v-col class="px-0">
                          <v-btn
                            :style="buttonProps"
                            outlined
                            :key="widgetKey"
                            @click.once="sb"
                            class="spc_ipad resp_tel_inp_width"
                          >
                          <span :style="btnTextProps">
                            {{ buttonText }}
                          </span>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item :value="getTabKeyWa" style="width:100%;" :style="bdyColor" class="py-0 ">

                        <v-col cols="12" class="px-0 py-0" style="padding-left:6%;height: 80px  !Important" :style="bdyColor">
<!--                          <v-col style="max-width: 145px !important;margin-top:5%;height: 50px !important;"-->
<!--                                 v-if=" stateLoading" class="px-0 py-0 ps_rel_100" cols="12">-->
<!--                            <v-progress-linear-->
<!--                              color="blue-grey lighten-3"-->
<!--                              indeterminate-->
<!--                              rounded-->
<!--                              height="2"-->
<!--                            ></v-progress-linear>-->
<!--                          </v-col>-->
                          <v-col class="px-0 py-0 resp_tel_inp_width" style="height: 36px !important;" >
                            <vue-tel-input-vuetify
                              type="number"
                              v-model="optinNumWhatsApp"
                              v-bind="bindProps"
                              v-on:country-changed="countryChanged"
                              @onValidate="btnDisabled = $event.valid"
                              @keydown="checkValidNumber($event)"
                              required
                              :placeholder="$t('settingsPage.addYourPhoneNumber')"
                              label=""
                              class="phone_number_section "
                              style="width: 100% !important;"
                              :class="{ 'alerts-border': displaeErr }"

                            >
                            </vue-tel-input-vuetify>
                          </v-col>
                          <v-col cols="12" class="px-0 " align="start">
                            <v-btn
                              :style="buttonProps"
                              outlined
                              :key="widgetKey"
                              @click.once="submitWhatsApp"
                              class="spc_ipad resp_tel_inp_width"
                            >
                              <span :style="btnTextProps">
                                {{ buttonText }}
                              </span>
                            </v-btn>

                          </v-col>
                        </v-col>

                    </v-tab-item>
                  </v-tabs-items>
                </v-col>
                <v-row style="width:100%; padding-left:12px" align="start">

                </v-row>
              </v-col>
            </v-col>
          </v-row>

          <v-row
            class="sp_tel_in  no_sp_any_resp"
            align="center"
            justify="center"
            v-if="!isDisc"
          >
            <v-col class="px-0 py-0 d-flex justify-center">
              <v-tabs-items v-model="tab" style="width:100%" :style="bdyColor">
                <v-tab-item :value="getTabKeySMS" style="width:100%" >
                  <v-col cols="12" class="no_sp_any_resp d-flex justify-center" style="height:60px" >
<!--                    <v-col-->
<!--                      class="px-0 py-0 mt-5"-->
<!--                      style="max-width:145px"-->
<!--                      v-if="!loadReady"-->
<!--                      cols="12"-->
<!--                    >-->
<!--                      <v-progress-linear-->
<!--                        color="blue-grey lighten-3 "-->
<!--                        indeterminate-->
<!--                        rounded-->
<!--                        height="2"-->
<!--                      ></v-progress-linear>-->
<!--                    </v-col>-->
<!--                    <vue-tel-input-vuetify-->
<!--                      type="number"-->
<!--                      v-model="optinNum"-->
<!--                      v-bind="bindProps"-->
<!--                      v-on:country-changed="countryChanged"-->
<!--                      @onValidate="btnDisabled = $event.valid"-->
<!--                      @keydown="checkValidNumber($event)"-->
<!--                      required-->
<!--                      label=""-->
<!--                      class="phone_number_section"-->
<!--                      placeholder=""-->
<!--                      v-show="loadReady"-->
<!--                      :class="{ 'alerts-border': displaeErr }"-->
<!--                    >-->
<!--&lt;!&ndash;                      :placeholder="$t('settingsPage.addYourPhoneNumber')"&ndash;&gt;-->
<!--                    </vue-tel-input-vuetify>-->


                    <vue-tel-input
                      v-model="optinNum"
                      dark
                      style="width:100%; height:35px !important ;"
                      :showDialCode="true"
                      mode="international"
                      :class="{ 'alerts-border': displaeErr }"
                      :style="telNumErr"
                      type="number"
                      v-on:country-changed="countryChanged"
                      @onValidate="btnDisabled = $event.valid"
                      @keydown="checkValidNumber($event)"
                      required
                      :placeholder="$t('settingsPage.addYourPhoneNumber')"
                      :label="$t('settingsPage.addYourPhoneNumber')"
                      class="phone_number_section"
                    >
                    </vue-tel-input>
                  </v-col>

                </v-tab-item>
                <v-tab-item :value="getTabKeyFb">
                  <v-col cols="10" class="py-0 px-0 " s>
                    <v-col class="resp_mrg py-0 px-0 d-flex justify-center" cols="12" style="height: 60px !important;">
                      <v-col
                        class="px-0 py-0 mt-5"
                        style="max-width:145px;margin-left: 14%"
                        v-if="!checkRendered"
                        cols="12"
                      >
                        <v-progress-linear
                          color="blue-grey lighten-3"
                          indeterminate
                          rounded
                          height="2"
                        ></v-progress-linear>
                      </v-col>
                      <component v-bind:is="currentTabComponent" > </component>
                    </v-col>
                  </v-col>
                </v-tab-item>
                <v-tab-item :value="getTabKeyWa" :style="bdyColor"  class="height_73">
                  <v-col cols="12" class="no_sp_any_resp d-flex justify-center" style="height:60px" >
<!--                    <v-col-->
<!--                      class="px-0 py-0 mt-5"-->
<!--                      style="max-width:145px"-->

<!--                      cols="12"-->
<!--                    >-->
<!--                      <v-progress-linear-->
<!--                        color="blue-grey lighten-3 "-->
<!--                        indeterminate-->
<!--                        rounded-->
<!--                        height="2"-->
<!--                      ></v-progress-linear>-->
<!--                    </v-col>-->
                    <vue-tel-input-vuetify
                      type="number"
                      v-model="optinNumWhatsApp"
                      v-bind="bindProps"
                      v-on:country-changed="countryChanged"
                      @onValidate="btnDisabled = $event.valid"
                      @keydown="checkValidNumber($event)"
                      required
                      :placeholder="$t('settingsPage.addYourPhoneNumber')"
                      label=""
                      class="phone_number_section"
                      style="width: 100%"
                      :class="{ 'alerts-border': displaeErr }"

                    >
                    </vue-tel-input-vuetify>
                  </v-col>
                </v-tab-item>
              </v-tabs-items>
            </v-col>

          </v-row>
          <v-col cols="12" v-if="!isDisc"   align="center"
                 justify="center" class="px-0 py-0 wdg_view_sms_tel">
            <v-col cols="9" class="px-0 d-flex justify-center" >
              <v-row style="max-width:260px !important;" justify="center">
                <v-btn
                  :style="buttonProps"
                  outlined
                  :key="widgetKey"
                  @click.once="sb('NoDisc')"
                  class="spc_ipad mt-0"
                >
                    <span :style="btnTextProps">
                      {{ buttonText }}
                    </span>
                </v-btn>

                <!--                        <v-btn-->
                <!--                          v-if="btnDisabled"-->
                <!--                          :style="bindPropsSec"-->
                <!--                          outlined-->
                <!--                          :key="widgetKey"-->
                <!--                          @click.once="submitClickDisc"-->
                <!--                        >-->
                <!--                        <span :style="btnTextProps">-->
                <!--                          {{ buttonText }}-->
                <!--                        </span>-->
                <!--                        </v-btn>-->
                <!--                        <v-btn-->
                <!--                          v-if="!btnDisabled"-->
                <!--                          :style="disButtonStyleSec"-->
                <!--                          outlined-->
                <!--                          depressed-->
                <!--                          disabled-->
                <!--                        >-->
                <!--                        <span :style="btnTextProps">-->
                <!--                          {{ buttonText }}-->
                <!--                        </span>-->
                <!--                        </v-btn>-->
              </v-row>
            </v-col>
          </v-col>
          <v-row style=" width:100%" v-if="!isDisc"> </v-row>

          <!--          /* title with text */-->
          <v-row
            class="mt-3"
            align="center"
            justify="center"
          >
            <span :style="titleProps" class="mb_title">{{ titleText }}</span>
          </v-row>
          <v-row
            align="center"
            justify="center"
          >

            <v-col class="no_any_spc">
              <p :style="msgProps" class="mb-0 mb_text">{{ msgText }}</p>
            </v-col>
          </v-row>

<!--          /* close button footer */-->
          <v-row
            class="mt-2"
            style=""
            align="end"
            justify="center"
            v-if="!checkOptin"
          >
            <a :style="cancelProps" @click="cancelClick">{{ cancelText }}</a>
          </v-row>
          <v-row
            class="mt-2"
            style=""
            align="end"
            justify="center"
            v-if="checkOptin"
          >
            <a :style="cancelProps" @click="cancelClick">Close</a>
          </v-row>
        </v-container>
      </v-card>
    </v-row>
    <!-- <v-alert light v-if="retCpyDone" style="margin-top:5%;" dense text outlined>
      Discount Code Copied Successfully
    </v-alert> -->
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import MessengerCheckbox from "./MessengerCheckbox.vue";
import DummyDiv from "./DummyDiv.vue";
import Vue from "vue";
import SmsIcon from "@/assets/icons/sms-icon.svg";
import FbIcon from "@/assets/icons/facebook-icon.svg";
import WaIcon from "@/assets/icons/wa-icon.svg";
import CloseIcon from "@/assets/icons/close.svg";

export default {
  name: "WidgetViewTabsMobile",
  components: {
    MessengerCheckbox,
    DummyDiv,
    SmsIcon,
    WaIcon,
    FbIcon, //DiscIcon
    CloseIcon,
  },
  data() {
    return {
      dialog: false,
      btnId: 0,
      tab: null,
      optinNum: "",
      optinNumWhatsApp:"",
      discImg: require("@/assets/img/discount-icon.png"),
      didOptIn: false,
      cpyDone: false,
      btnDisabled: false,
      phone:"",
      bindProps: {
        mode: "international",
        placeholder: "Enter a phone number",
        required: false,
        enabledCountryCode: true,
        enabledFlags: true,
        autocomplete: "off",
        name: "telephone",
        maxLen: 25,
        inputOptions: {
          showDialCode: true
        },
        reg:null,
      },
      disButtonStyle:{
        "background-color":'rgba(0,0,0,.12)!important',
        "width": "100%",
      },
      bindPropsSec: {
        "background-color":'rgb(0, 106, 255) !important',
        "width": "100%",
        "margin":"0px auto"
      },
      disButtonStyleSec:{
        "background-color":'rgba(0,0,0,.12)!important',
        "width": "100%",
        "margin":"0px auto"
      },
      ButtonBoth:{
        "background-color":'rgb(0 106 255) !important',
        "width": "100%",
      },
      disButtonBoth:{
        "background-color":'rgba(0,0,0,.12)!important',
        "width": "100%",
        "margin":"0px auto"
      },
      fbTab:true,

      stateLoading:false,
    };
  },
  methods: {
    countryChanged(country) {
      setTimeout(()=> {this.optinNum == '' ? this.optinNum = '+' + country.dialCode : this.optinNum.length > 4 && this.first == true ? this.optinNum = '+' + country.dialCode: this.optinNum,
        this.btnDisabled = false},300)
      if(country.dialCode !== null){
        this.country = '+' + country.dialCode
      }
    },
    checkValidNumber(event){
      switch (event.code){
        case 'Backspace':

          break;
        case 'Delete':

          break;
        case 'ArrowUp':

          break;
        case 'ArrowDown':

          break;
        case 'ArrowLeft':

          break;
        case 'ArrowRight':

          break;
        default: (/[a-zA-Z]/).test( event.key) == true ? event.preventDefault() : ''
      }
    },
    tabVal() {
      // console.log(this.tab);
    },
    incrBtnId() {
      this.btnId++;
    },
    toggleDialog() {
      this.dialog = !this.dialog;
    },
    resetChanges() {
      this.$store.dispatch("getWidgets");
    },
    cancelClick() {
      this.$store.dispatch("toggleDisplay");
    },
    // submitDiscClick(item){
    //   if(this.tab == 0 && this.getTabHeader1 == 'FbIcon' && this.getTabHeader2 == 'SmsIcon'){
    //     this.submitClick(item)
    //   }else if(this.tab == 1 && this.getTabHeader1 == 'FbIcon' && this.getTabHeader2 == 'SmsIcon'){
    //     this.submitClickDisc(item)
    //   }else if(this.tab == 0 && this.getTabHeader1 == 'SmsIcon' && this.getTabHeader2 == 'FbIcon'){
    //     this.submitClickDisc(item)
    //   }else if(this.tab == 1 && this.getTabHeader1 == 'SmsIcon' && this.getTabHeader2 == 'FbIcon'){
    //     this.submitClick(item)
    //   }
    // },
    sb(item){
      if((this.tab == 0 && this.getTabHeader1 == 'FbIcon') || (this.tab == 1 && this.getTabHeader2 == 'FbIcon' )
        || (this.tab == 2 && this.getTabHeader3 == 'FbIcon' )){
        this.submitClick(item)
      }
      else if((this.tab == 0 && this.getTabHeader1 == 'SmsIcon') || (this.tab == 1 && this.getTabHeader2 == 'SmsIcon')
        || (this.tab == 2 && this.getTabHeader3 == 'SmsIcon')){
        this.submitClickDisc(item)
      }
      else if((this.tab == 0 && this.getTabHeader1 == "WaIcon") || (this.tab == 1 && this.getTabHeader2 == "WaIcon")
        || (this.tab == 2 && this.getTabHeader3 == "WaIcon")){
        this.submitWhatsApp(item)
      }else console.log('no action')
    },
    submitWhatsApp(item){
      if(this.optinNumWhatsApp != "" && this.btnDisabled == true){
        this.didOptIn = true;
        let obj = {
          instance_id: document.querySelector("widget-view").instance_id,
          cart_id: document.querySelector("widget-view").cart_id,
          user_ref: this.optinNumWhatsApp,
        };
        /* hint ` change it later ,make it whatsapp */
        this.$store.dispatch("sendWaOptin", obj);
        if(item == 'NoDisc'){
          this.$store.dispatch("toggleDisplay");
        }
      }else {
        this.$store.dispatch("setErrFlashFB", true).then(() => {
          this.incrBtnId();
          setTimeout(() => {
            this.$store.dispatch("setErrFlashFB", false);
          }, 1000);
        });
      }
    },
    submitClick(item) {

      if (this.$store.getters.getCheckBoxState == "checked") {
        this.$store.dispatch("toggleDisplay");
        Vue.FB.AppEvents.logEvent("MessengerCheckboxUserConfirmation", null, {
          app_id: this.getMessengerId,
          page_id: this.getFbPgId,
          ref: this.$store.getters.getInstanceId,
          user_ref: this.$store.getters.getCheckBoxUserRef,
        });
        if(item == 'NoDisc'){
          this.$store.dispatch("toggleDisplay");
        }
      } else {
        this.$store.dispatch("setErrFlashFB", true).then(() => {
          this.incrBtnId();
          setTimeout(() => {
            this.$store.dispatch("setErrFlashFB", false);
          }, 1000);
        });
      }

    //   if (
    //     this.tab ==
    //     this.$store.getters.getWidgetsState.enabled_widgets.facebook - 1
    //   ) {
    //     if (this.$store.getters.getCheckBoxState == "checked") {
    //       Vue.FB.AppEvents.logEvent("MessengerCheckboxUserConfirmation", null, {
    //         app_id: this.getMessengerId,
    //         page_id: this.getFbPgId,
    //         ref: this.$store.getters.getInstanceId,
    //         user_ref: this.$store.getters.getCheckBoxUserRef,
    //       });
    //       if(item == 'NoDisc'){
    //         this.$store.dispatch("toggleDisplay");
    //       }
    //     } else {
    //       this.$store.dispatch("setErrFlashFB", true).then(() => {
    //         this.incrBtnId();
    //         setTimeout(() => {
    //           this.$store.dispatch("setErrFlashFB", false);
    //         }, 1000);
    //       });
    //     }
    //   }
    //   else {
    //
    //     // console.log(this.optinNum);
    //     if (this.optinNum != "") {
    //       let obj = {
    //         instance_id: document.querySelector("widget-view").instance_id,
    //         cart_id: document.querySelector("widget-view").cart_id,
    //         user_ref: this.optinNum,
    //       };
    //       this.$store.dispatch("sendSMSOptin", obj);
    //       this.$store.dispatch("toggleDisplay");
    //     } else {
    //       this.$store.dispatch("setErrFlashFB", true).then(() => {
    //         this.incrBtnId();
    //         setTimeout(() => {
    //           this.$store.dispatch("setErrFlashFB", false);
    //         }, 1000);
    //       });
    //     }
    //   }
    },
    submitClickDisc(item) {

      if (this.optinNum != "" && this.btnDisabled == true) {
        // console.log(this.optinNum);
        this.didOptIn = true;
        let obj = {
          instance_id: document.querySelector("widget-view").instance_id,
          cart_id: document.querySelector("widget-view").cart_id,
          user_ref: this.optinNum,
        };
        this.$store.dispatch("sendSMSOptin", obj);
        if(item == 'NoDisc'){
          this.$store.dispatch("toggleDisplay");
        }
      } else {
        this.$store.dispatch("setErrFlashFB", true).then(() => {
          this.incrBtnId();
          setTimeout(() => {
            this.$store.dispatch("setErrFlashFB", false);
          }, 1000);
        });
      }

      // if (this.optinNum != "" && this.btnDisabled == true) {
      //   // console.log(this.optinNum);
      //   this.didOptIn = true;
      //   let obj = {
      //     instance_id: document.querySelector("widget-view").instance_id,
      //     cart_id: document.querySelector("widget-view").cart_id,
      //     user_ref: this.optinNum,
      //   };
      //   this.$store.dispatch("sendSMSOptin", obj);
      //   if(item == 'NoDisc'){
      //     this.$store.dispatch("toggleDisplay");
      //   }
      // } else {
      //   this.$store.dispatch("setErrFlashFB", true).then(() => {
      //     this.incrBtnId();
      //     setTimeout(() => {
      //       this.$store.dispatch("setErrFlashFB", false);
      //     }, 1000);
      //   });
      // }

    },
    cpySuccess() {
      this.cpyDone = true;
      setTimeout(() => {
        this.cpyDone = false;
      }, 1500);
    },
  },
  computed: {
    ...mapGetters(["getWidgetsState", "getFbDetails", "getCheckBoxRendered"]),

    discImgSrc() {
      return  `${process.env.VUE_APP_CLOUD_STORAGE_URL}/widget/img/discount-icon.png`;
    },
    FrThTabHeader(){
      return this.getTabHeader1 !== false && this.getTabHeader2 == false && this.getTabHeader3 !== false
    },
    allTabHeader(){
      return this.getTabHeader1 !== false && this.getTabHeader2 !== false && this.getTabHeader3 !== false
    },
    styleHeader1() {
      if (this.tab == 0) {
        return { opacity: 1 };
      } else {
        return { opacity: 0.3 };
      }
    },
    styleHeader2() {
      if (this.tab == 1) {
        return { opacity: 1 };
      } else {
        return { opacity: 0.3 };
      }
    },
    styleHeader3() {
      if (this.tab == 2) {
        return { opacity: 1 };
      } else {
        return { opacity: 0.3 };
      }
    },
    cpyBtnTxt() {
      if (this.cpyDone) {
        return "COPIED!";
      } else {
        return "COPY DISCOUNT CODE";
      }
    },
    displaeErr() {
      return this.$store.getters.getErrFlashFB;
    },
    telNumErr() {
      let obj = { "border-color": "#ff0000" };
      if (this.$store.getters.getErrFlashFB) {
        return obj;
      } else {
        return {};
      }
    },
    checkOptin() {
      return this.didOptIn;
    },
    isDisc() {
      return this.getWidgetsState.subscribe_type == "subscribe" ? true : false;
    },
    cardHeight() {
      return this.getWidgetsState.subscribe_type == "subscribe"
        ? "600px"
        : "600px";
    },
    retCpyDone() {
      return this.cpyDone;
    },
    getTabHeader1() {
      if (this.getWidgetsState.enabled_widgets.sms == 1) {
        return "SmsIcon";
      } else if(this.getWidgetsState.enabled_widgets.facebook == 1){
        return "FbIcon";
      } else if(this.getWidgetsState.enabled_widgets.whatsapp == 1){
        return "WaIcon";
      } else return false
    },
    getTabHeader2() {
      if (this.getWidgetsState.enabled_widgets.sms == 2) {
        return "SmsIcon";
      } else if(this.getWidgetsState.enabled_widgets.facebook == 2){
        return "FbIcon";
      } else if(this.getWidgetsState.enabled_widgets.whatsapp == 2){
        return "WaIcon";
      }else return false
    },
    getTabHeader3() {
      if (this.getWidgetsState.enabled_widgets.sms == 3) {
        return "SmsIcon";
      } else if(this.getWidgetsState.enabled_widgets.facebook == 3){
        return "FbIcon";
      }else if(this.getWidgetsState.enabled_widgets.whatsapp == 3){
        return "WaIcon";
      }else return false
    },
    getTabKeyFb() {
      // console.log(
      //   "facebookPos" + this.getWidgetsState.enabled_widgets.facebook
      // );
      return this.getWidgetsState.enabled_widgets.facebook - 1;
    },
    getTabKeySMS() {
      return this.getWidgetsState.enabled_widgets.sms - 1;
    },
    getTabKeyWa() {
      // return 0
      return this.getWidgetsState.enabled_widgets.whatsapp - 1;
    },
    getMessengerId() {
      return this.getFbDetails.messenger_app_id;
    },
    getFbPgId() {
      return this.getFbDetails.page_id;
    },
    detectChange() {
      return this.getWidgetsState.changesSaved;
    },
    currentTabComponent() {
      if (this.getFbDetails.div_class == "fb-send-to-messenger") {
        return "MessengerCheckbox";
      } else {
        return "DummyDiv";
      }
    },
    bcgColor() {
      let hdrClsObj = {
        "background-color": this.getWidgetsState.header_background_color,
      };
      return hdrClsObj;
    },
    bdyColor() {
      let bdyClsObj = {
        "background-color": this.getWidgetsState.popup_background_color,
      };
      return bdyClsObj;
    },
    titleText() {
      return this.getWidgetsState.pop_up_title;
    },
    titleProps() {
      let ttlObj = {
        color: this.getWidgetsState.pop_up_title_font_color,
        "font-weight": this.getWidgetsState.pop_up_title_font_type,
        "font-size": this.getWidgetsState.pop_up_title_font_size + "px",
        "font-family": this.getWidgetsState.pop_up_title_font_family,
      };
      return ttlObj;
    },
    msgText() {
      return this.getWidgetsState.pop_up_message;
    },
    msgProps() {
      let ttlObj = {
        color: this.getWidgetsState.pop_up_message_font_color,
        "font-weight": this.getWidgetsState.pop_up_message_font_type,
        "font-size": this.getWidgetsState.pop_up_message_font_size + "px",
        "font-family": this.getWidgetsState.pop_up_message_font_family,
        "text-align": "center",
      };
      return ttlObj;
    },
    dscntStmt() {
      return this.getWidgetsState.discount_statement;
    },
    dscntCd() {
      return this.getWidgetsState.discount_code;
    },
    dscntInstr() {
      return this.getWidgetsState.apply_discount_instruction;
    },
    cancelText() {
      return this.getWidgetsState.pop_up_cancel;
    },
    cancelProps() {
      let ttlObj = {
        color: this.getWidgetsState.pop_up_cancel_font_color,
        "font-weight": this.getWidgetsState.pop_up_cancel_font_type,
        "font-size": this.getWidgetsState.pop_up_cancel_font_size + "px",
        "font-family": this.getWidgetsState.pop_up_cancel_font_family,
        "text-decoration": "underline",
        "text-align": "center",
      };
      return ttlObj;
    },
    buttonText() {
      this.incrBtnId();

      return this.getWidgetsState.button_text;
    },
    buttonProps() {
      let borderRad =
        this.getWidgetsState.button_corners == "Round" ? "4px" : "0px";
      let buttonObj = {
        "background-color": this.getWidgetsState.button_background,
        "border-color": this.getWidgetsState.button_border_color,
        "border-radius": borderRad,
        "border-width": this.getWidgetsState.button_border_size + "px",
        width: "80%",
      };
      return buttonObj;
    },
    btnTextProps() {
      let btnObj = {
        color: this.getWidgetsState.button_font_color,
        "font-family": this.getWidgetsState.button_font_family,
        "font-weight": this.getWidgetsState.button_font_type,
        "font-size": this.getWidgetsState.button_font_size + "px",
        "text-transform": "none",
      };
      return btnObj;
    },
    widgetType() {
      return this.getWidgetsState.facebook_widget_type;
    },
    widgetKey() {
      return "key" + this.getWidgetsState.wdgt_key_internal + "b" + this.btnId;
    },
    checkRendered() {
      return this.getCheckBoxRendered;
    },
  },

  mounted() {
    this.tab = 1
    setTimeout(() => this.tab = 0,750)

    setTimeout(() => this.stateLoading = true ,450)
  },
  beforeCreate() {
    this.$store.dispatch("getWidgets");
    this.tab = "tab1";
  },
};
</script>

<style>
.header_height_resp{
  height: 100px;
}
.sp_tel_inp{
  padding-left:16px;
  padding-right: 8px;
}

[data-vuetify] .v-text-field > .v-input__control > .v-input__slot:before, [data-vuetify] .v-text-field > .v-input__control > .v-input__slot:after{
  width: 0% !important;
}
.phone_number_section{
  height: 35px !important;

}
.btn_disabled{

}
.fb-btn {
  border-radius: 7px;
  text-transform: none;
}

[data-vuetify] .theme--dark.v-sheet {
  background-color: #1e1e1e;
  border-color: #1e1e1e;
  color: #1e1e1e;
}
.v-slide-group__prev--disabled{
  display: contents !important;
}
.vue-tel-input {
  height: 40px !important;
  font-size: 100% !important;
  border-radius: 5px !important;
}

.alerts-border {
  border: 1px #ff0000 solid !important;
  animation: blink 1s !important;
  animation-iteration-count: 2 !important;
}

 /* animation other ways */
/*animation: blink 4s linear infinite;*/
/*animation: blink-animation 1s steps(5, start) infinite;*/
/*-webkit-animation: blink-animation 1s steps(5, start) infinite;*/
/*@keyframes blink{*/
/*  0%{opacity: 0;}*/
/*  50%{opacity: .5;}*/
/*  100%{opacity: 1;}*/
/*}*/

/*@keyframes blink-animation {*/
/*  to {*/
/*    visibility: hidden;*/
/*  }*/
/*}*/
/*@-webkit-keyframes blink-animation {*/
/*  to {*/
/*    visibility: hidden;*/
/*  }*/
/*}*/


@keyframes blink {
  50% {
    border-color: #fff !important;
  }
}
@media (max-height: 725px) {
  .header_height_resp{
    height: 50px !important;
  }
  .no_any_spc{
    padding-right: 0px !important;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
}


</style>
<style lang="css" scoped>
@media only screen and (max-width: 1025px) and (min-width: 540px)  {
  /*.img_height_ord{*/
  /*  height: 40vh !important;*/
  /*}*/
  /*.height_resp_350{*/
  /*  height: 50px !important;*/
  /*}*/
  /*.mb_text {*/
  /*  font-size: 8px!important;*/
  /*  text-align: start;*/
  /*}*/
}
</style>
<style lang="css">
.left_mrg_16{
  margin-left: 16px !Important;
}
.img_height_ord{
  height: 30vh !important;
}
.resp_mrg{
margin-left: 10% !important;
}
@media only screen and (max-width: 1025px) and (min-width: 540px){

  /*.ipad_resp{*/
  /*  padding-top:0px !important;*/
  /*  padding-bottom: 0px !important;*/
  /*  height: 100px !Important;*/
  /*}*/
  /*.ipad_flex{*/
  /*  align-items: unset !important;*/
  /*}*/
  /*.ipad_no_spc{*/
  /*  padding-top:0px !important;*/
  /*  padding-bottom: 0px !important;*/
  /*}*/
  /*.mb_text{*/
  /*  font-size: 8px !Important;*/
  /*}*/

}
@media (min-width: 750px) {
  .spc_ipad{
    margin-top: 25px !important;
  }
}
@media (max-width: 800px) {
  .resp_mrg{
    margin-left: 22% !important;
  }

}
@media (max-width: 550px) {
  .resp_mrg{
    margin-left: 26% !important;
  }
}
@media (max-width: 500px) {
  .resp_mrg{
    margin-left: 20% !important;
  }
  .no_y_spc_500{
    padding-bottom: 0px !important;
    padding-top: 0px !important;
  }

}
@media (max-width: 325px) {
  .resp_mrg{
    margin-left: 15% !important;
  }
}
@media (max-width: 300px) {
  .resp_mrg{
    margin-left: 15% !important;
  }
  .no_spc_less_300{
    margin-left:0px !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .pos_rel_5{
    position: relative;
    left: -5px !important;
  }
}
</style>
<style lang="css" scoped>
.resp_tel_inp_width{
width: 96% !important;
}
.pos_rel_5{
  position: relative;
  left: -5px !important;
}
@media (min-width: 750px) {
  .pos_rel_5{
    position: relative;
    left: -22px !important;
  }
}
@media (max-width: 550px) {
  .pos_rel_5{
    position: relative;
    left: -12px !important;
  }

}
@media (max-width: 300px) {
  .pos_rel_5{
    position: relative;
    left: 0px !important;
  }
}
</style>
